import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import vuescroll from "vuescroll";
import { mapGetters } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { SelectTimeInterface } from "@/components/Home/Services/ServiceTimeSelect/SelectTimeInterface";

const ServiceClinicCardProps = Vue.extend({
  props: {
    service: {
      type: [Object as () => ServiceInterface],
      default: null,
    },
    cepForm: {
      type: Boolean,
      default: true,
    },
    defaultLogo: {
      type: String,
      default: require("@/assets/images/Logo_nova.svg"),
    },
    clinicAvailableHours: {
      default: null,
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
});

@Component<ServiceClinicCard>({
  name: "service-clinic-card",
  components: {
    VueSlickCarousel,
  },
  computed: mapGetters(["getDate", "getAppointmentDate"]),
})
export default class ServiceClinicCard extends ServiceClinicCardProps {
  cx_vueScroll?: vuescroll;
  getDate!: string;

  cx_vueScrollOption = {
    vuescroll: {},
    scrollPanel: {
      initialScrollY: false,
      initialScrollX: "0%",
      scrollingX: true,
      scrollingY: false,
      speed: 300,
      easing: undefined,
      verticalNativeBarPos: "right",
    },
    rail: {
      gutterOfEnds: "19px",
    },
    bar: {
      background: "#C4C4C4",
    },
  };

  settings = {
    "dots": false,
    "focusOnSelect": false,
    "infinite": false,
    "speed": 500,
    "slidesToShow": screen.width <= 1200 ? 3 : 6,
    "slidesToScroll": 1,
    "touchThreshold": 5,
  };

  cx_service = this.service;
  cx_cepForm = this.cepForm;
  cx_defaultLogo = this.defaultLogo;
  cx_loading = this.loading;
  cx_clinic_rating = this.service.clinic_rating ? this.service.clinic_rating : 0;
  cx_rating_count = this.service.rating_count ? this.service.rating_count : 0;

  created(): void {
    this.cx_vueScroll = this.$refs["vs"] as vuescroll;
  }

  formattedAddress(address: any): string {
    const stringAddress = `${address.street}, ${address.number} - ${address.neighbourhood}, ${address.city.name}/${address.city.state.abbreviation}`;
    return stringAddress;
  }

  formattedDistance(distance: any): string {
    const stringDistance = `${parseFloat(distance).toFixed(1)} km`.replace('.', ',');
    return stringDistance;
  }

  formattedCurrency(str: string): string {
    return parseFloat(str).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  selectTime(availableHour: SelectTimeInterface, $event: any, clinicId: string): void {
    availableHour.time = availableHour.start;
    availableHour.clinic_id = clinicId;
    availableHour.selected = true;
    this.$store.commit("setTime", availableHour);
    if(document.getElementsByClassName('selected-time').length > 0 && $event.target !== document.getElementsByClassName('selected-time')[0]) {
      document.getElementsByClassName('selected-time')[0]?.classList.remove("selected-time");
    }

    if ($event.target.classList[1] === 'selected-time') {
      this.$store.commit("setTime", {});
      $event.target.classList.remove('selected-time')
    } else {
      $event.target.classList.add('selected-time')
    }
  }
}
